<template>
  <div class="choice" :class="{ selected }" @click="$emit('click')">
    <div class="circle"></div>
    <div class="address">{{ address | address }}</div>
    <div class="status">
      ({{ recommended ? "Recommended" : "Not verified" }})
    </div>
  </div>
</template>

<script>
export default {
  name: "MailingAddressChoice",
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    address: Object,
    recommended: {
      type: Boolean,
      default: false
    },
    showRec: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.choice {
  border: 1px solid #d3d6de;
  padding: 20px;
  border-radius: 10px;
  line-height: 21px;
  font-size: 0.875rem;
  cursor: pointer;

  &.selected {
    background-color: #f7f8fa;
    font-weight: bold;

    .circle {
      border: 0;
      background-color: #007ea8;

      &::after {
        content: url("~@Shared/assets/images/check.svg");
        padding: 0 3px;
        display: block;
      }
    }
  }

  .circle {
    width: 21px;
    height: 21px;
    border: 2px solid #d3d6de;
    border-radius: 100%;
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
  }

  .address {
    display: inline-block;
    width: calc(100% - 160px);
    word-break: break-word;
  }

  .status {
    display: inline-block;
    float: right;
  }
}
</style>
